import React 			from 'react';
import PropTypes 	from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx';

export default class FloatingImage extends BLComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		
		return (
			<div className={"floating-image " + classes}>
				{this.props.children}
			</div>
		);
	}
}

FloatingImage.propTypes = {
		classes: PropTypes.string
};